"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    ReactLink = require("react-router-dom").Link,
    LinkSubTabItem = function LinkSubTabItem(e) {
  var s = classnames("blx-sub-tab", {
    "blx-active": e.active,
    "blx-hidden": !e.visible,
    "blx-disabled": e.disabled
  }),
      a = e.useReactLink ? React.createElement(ReactLink, {
    className: s,
    to: e.href
  }, e.text) : React.createElement("a", {
    className: s,
    href: e.href
  }, e.text);
  return React.createElement("div", {
    style: e.style,
    className: e.className
  }, a, e.children);
};

LinkSubTabItem.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  text: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  active: PropTypes.bool,
  disabled: PropTypes.bool
}, LinkSubTabItem.defaultProps = {
  className: "",
  style: null,
  visible: !0,
  active: !1,
  disabled: !1
}, module.exports = LinkSubTabItem;